import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import {APPLICATION, ENVIRONMENT, LOCALE} from "./config";

const theme = createTheme({
  typography: {
    fontFamily: ["Open Sans", "sans-serif"].join(","),
  },
});

const root = ReactDOM.createRoot(
  document.getElementById("performanceCalculatorReact") as HTMLElement,
);

root.render(
  <ThemeProvider theme={theme}>
    <React.StrictMode>
      <App locale={LOCALE} environment={ENVIRONMENT} application={APPLICATION} />
    </React.StrictMode>
  </ThemeProvider>,
);
